var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "zoomContainer", attrs: { id: "zoomContainer" } },
    _vm._l(_vm.$store.state.ui.contentControls, function (item, index) {
      return _c("content-control", {
        key: index,
        attrs: { "content-control-item": item },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }